import React from 'react';

interface Props {
  onClick?: () => void;
  className?: string;
}

const FullscreenIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 5V1H5M9 1H13V5M13 9V13H9M5 13H1V9"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const PlayerFullscreenButton = ({onClick, className}: Props) => (
  <button className={className} onClick={onClick}>
    <FullscreenIcon />
  </button>
);

export default PlayerFullscreenButton;
